module.exports = __webpack_public_path__ + "04_short_brown.24ca0562.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/04_short_brown.png
// module id = UVk6
// module chunks = 0